import {
  useList,
  EditButton,
  CreateButton,
  Toolbar,
  BulkDeleteButton,
  FunctionField,
  useNotify,
} from "react-admin";
import { RaListContextProviderWrapper } from "../../components/RaListContextProviderWrapper";
import { useResourceList } from "../../hooks/useResourceList";
import {
  MovingItemPayload,
  OrderableDatagrid,
} from "../../components/OrderableDatagrid";

const ListActions = () => (
  <Toolbar>
    <CreateButton label={"New Lodging Type"} />
  </Toolbar>
);

const LodgingTypesBulkActionButtons = ({ onDelete }: any) => {
  const confirmMsg = `
    Are you sure you want to delete?
  `;

  return (
    <>
      <BulkDeleteButton
        mutationMode="optimistic"
        mutationOptions={{ onSettled: () => onDelete() }}
        confirmContent={confirmMsg}
      />
    </>
  );
};

const LodgingTypesList = () => {
  const { state, items, updateResources, refetch } =
    useResourceList("lodging-types");
  const notify = useNotify();

  const updateLodgingTypeOrder = async (itemsPayload: MovingItemPayload[]) => {
    notify("Updating lodging type order...");

    await updateResources(itemsPayload);

    notify("Lodging types order updated.");

    refetch();
  };

  const mappedLodgingTypes = items?.map((item, itemIndex: number) => {
    return {
      ...item,
      index: itemIndex,
    };
  });

  const listContext = useList({
    data: mappedLodgingTypes,
    isLoading: !Array.isArray(items) && state === "loading",
  });

  // Custom FunctionFields.
  const renderName = (record: any) => {
    return (
      <span className={`record-name ${!record.enabled && "disabled-name"}`}>
        {record.name}
      </span>
    );
  };

  const renderEnabled = (record: any) => {
    return record.enabled ? (
      "Enabled"
    ) : (
      <span className={`${!record.enabled && "disabled-name"}`}>Disabled</span>
    );
  };

  return (
    <RaListContextProviderWrapper value={listContext}>
      <ListActions />
      <OrderableDatagrid
        items={items ?? []}
        isLoading={state === "loading"}
        onUpdateOrder={updateLodgingTypeOrder}
        bulkActionButtons={<LodgingTypesBulkActionButtons onDelete={refetch} />}
      >
        <FunctionField label="Name" render={renderName} />
        <FunctionField label="Enabled?" render={renderEnabled} />
        <EditButton className="editToHover" label="Edit" />
      </OrderableDatagrid>
    </RaListContextProviderWrapper>
  );
};

export default LodgingTypesList;
